// BEGIN hrigPlusOneGloveClipThumbnail20260716
;(function hrigPlusOneGloveClipThumbnail20260716() {
  var config = {
  "handle": "seibertron-high-vis-dexterity-super-grip-gel-oil-gas-anti-vibration-impact-protection-safety-gloves",
  "targetStyle": "HRC5+1 Glove Clip",
  "entries": [
    {
      "id": "33448522875070",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-main-white-20260715.jpg?v=1784079529",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:1 | Seibertron HIGH-VIS HRC5 safety gloves white background product image"
    },
    {
      "id": "33448522907838",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-overview-20260715.jpg?v=1784079529",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:2 | Seibertron HIGH-VIS HRC5 safety gloves high-vis oil and gas overview image"
    },
    {
      "id": "33448522940606",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-impact-rating-20260715.jpg?v=1784079529",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:3 | Seibertron HIGH-VIS HRC5 safety gloves TPR impact protection and CE ANSI rating detail image"
    },
    {
      "id": "33448522973374",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-palm-clip-20260715.jpg?v=1784079529",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:4 | Seibertron HIGH-VIS HRC5 safety gloves palm and glove clip detail image"
    },
    {
      "id": "33448523006142",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-detail-panels-20260715.jpg?v=1784079529",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:5 | Seibertron HIGH-VIS HRC5 safety gloves product detail panels"
    },
    {
      "id": "33448523038910",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-best-use-20260715.jpg?v=1784079529",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:6 | Seibertron HIGH-VIS HRC5 safety gloves best use application image"
    },
    {
      "id": "33448523071678",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-safety-gloves-size-chart-20260715.jpg?v=1784079528",
      "alt": "seibertron-gallery:hrc5-safety-gloves-20260715 | product:hrc5 | color:Red Yellow | slot:7 | Seibertron HIGH-VIS HRC5 safety gloves adult size chart image"
    },
    {
      "id": "33455741141182",
      "src": "https://cdn.shopify.com/s/files/1/0623/6153/4654/files/seibertron-hrc5-plus-1-glove-clip-thumbnail-20260716.png?v=1784192352",
      "alt": "seibertron-gallery:hrc5-plus-1-glove-clip-thumbnail-20260716 | product:hrc5 | style:HRC5+1 Glove Clip | Seibertron HIGH-VIS HRC5 gloves with one black glove clip"
    }
  ],
  "variants": [
    {
      "id": "41897973940414",
      "availableForSale": true,
      "values": [
        "HRC5",
        "Small"
      ],
      "style": "HRC5",
      "mediaId": "33448522875070"
    },
    {
      "id": "41897974464702",
      "availableForSale": true,
      "values": [
        "HRC5",
        "Medium"
      ],
      "style": "HRC5",
      "mediaId": "33448522875070"
    },
    {
      "id": "41897973842110",
      "availableForSale": true,
      "values": [
        "HRC5",
        "Large"
      ],
      "style": "HRC5",
      "mediaId": "33448522875070"
    },
    {
      "id": "41897974497470",
      "availableForSale": true,
      "values": [
        "HRC5",
        "X-Large"
      ],
      "style": "HRC5",
      "mediaId": "33448522875070"
    },
    {
      "id": "41897974038718",
      "availableForSale": true,
      "values": [
        "HRC5",
        "XX-Large"
      ],
      "style": "HRC5",
      "mediaId": "33448522875070"
    },
    {
      "id": "41897973973182",
      "availableForSale": true,
      "values": [
        "HRC5+1 Glove Clip",
        "Small"
      ],
      "style": "HRC5+1 Glove Clip",
      "mediaId": "33455741141182"
    },
    {
      "id": "41897973907646",
      "availableForSale": true,
      "values": [
        "HRC5+1 Glove Clip",
        "Medium"
      ],
      "style": "HRC5+1 Glove Clip",
      "mediaId": "33455741141182"
    },
    {
      "id": "41897973874878",
      "availableForSale": true,
      "values": [
        "HRC5+1 Glove Clip",
        "Large"
      ],
      "style": "HRC5+1 Glove Clip",
      "mediaId": "33455741141182"
    },
    {
      "id": "41897974005950",
      "availableForSale": true,
      "values": [
        "HRC5+1 Glove Clip",
        "X-Large"
      ],
      "style": "HRC5+1 Glove Clip",
      "mediaId": "33455741141182"
    },
    {
      "id": "41897974071486",
      "availableForSale": true,
      "values": [
        "HRC5+1 Glove Clip",
        "XX-Large"
      ],
      "style": "HRC5+1 Glove Clip",
      "mediaId": "33455741141182"
    }
  ],
  "styleMedia": {
    "HRC5": "33448522875070",
    "HRC5+1 Glove Clip": "33455741141182"
  }
};
  var applying = false;
  function root() {
    return document.querySelector('.auto-product[data-product-handle="' + config.handle + '"]');
  }
  function absolute(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    if (url.charAt(0) === '/') return window.location.origin + url;
    return url;
  }
  function sized(url, width) {
    try {
      var parsed = new URL(absolute(url), window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.href;
    } catch (error) {
      return absolute(url);
    }
  }
  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function selectedValues(scope) {
    return Array.prototype.slice.call(scope.querySelectorAll('input[name^="options["]:checked')).map(function (input) { return input.value || ''; });
  }
  function selectedVariant(scope) {
    var values = selectedValues(scope);
    return config.variants.find(function (variant) {
      return variant.values.length === values.length && variant.values.every(function (value, index) { return value === values[index]; });
    }) || null;
  }
  function entryById(id) {
    return config.entries.find(function (entry) { return String(entry.id) === String(id); }) || null;
  }
  function setMain(scope, entry) {
    var main = scope.querySelector('[data-auto-main-image]');
    if (!main || !entry) return;
    main.src = sized(entry.src, 1200);
    main.srcset = '';
    main.alt = entry.alt || main.alt || '';
  }
  function syncPurchase(scope, variant) {
    if (!variant) return;
    scope.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (field) {
      if (String(field.value || '') !== String(variant.id)) {
        field.value = variant.id;
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    scope.querySelectorAll('form[action*="/cart/add"] button[type="submit"]').forEach(function (button) {
      button.disabled = !variant.availableForSale;
      button.setAttribute('aria-disabled', variant.availableForSale ? 'false' : 'true');
    });
  }
  function ensureThumb(scope, wrap, entry, index) {
    var thumb = wrap.querySelector('[data-auto-thumb][data-media-id="' + entry.id + '"]');
    if (!thumb) {
      thumb = document.createElement('button');
      thumb.type = 'button';
      thumb.className = 'auto-product__thumb';
      thumb.setAttribute('data-auto-thumb', '');
      wrap.appendChild(thumb);
    }
    thumb.setAttribute('data-media-id', entry.id);
    thumb.setAttribute('data-safe-gallery-media', 'true');
    thumb.setAttribute('data-src', sized(entry.src, 1200));
    thumb.setAttribute('data-alt', entry.alt || '');
    thumb.setAttribute('aria-label', 'View image ' + (index + 1));
    thumb.setAttribute('aria-hidden', 'false');
    thumb.hidden = false;
    thumb.style.display = '';
    var image = thumb.querySelector('img');
    if (!image) {
      thumb.innerHTML = '<img src="' + escapeHtml(sized(entry.src, 160)) + '" alt="' + escapeHtml(entry.alt || '') + '" width="76" height="76" loading="lazy">';
    }
    if (thumb.dataset.hrigClipBound !== 'true') {
      thumb.dataset.hrigClipBound = 'true';
      thumb.addEventListener('click', function () { setMain(scope, entry); });
    }
  }
  function syncStyleChoices(scope) {
    scope.querySelectorAll('.auto-product__choice--visual').forEach(function (choice) {
      var input = choice.querySelector('input[name="options[Style]"]');
      if (!input) return;
      var mediaId = config.styleMedia[input.value];
      var entry = entryById(mediaId);
      if (!entry) return;
      var image = choice.querySelector('img');
      if (!image) return;
      var expected = sized(entry.src, 180);
      if (image.src !== expected) image.src = expected;
      if (image.srcset) image.srcset = '';
      if (image.alt !== input.value) image.alt = input.value;
      choice.setAttribute('data-variant-media-id', mediaId);
    });
  }
  function enforceExactState(scope) {
    var clipId = config.styleMedia[config.targetStyle];
    var clipThumb = scope.querySelector('[data-auto-thumb][data-media-id="' + clipId + '"]');
    if (clipThumb) {
      if (clipThumb.hidden) clipThumb.hidden = false;
      if (clipThumb.style.display === 'none') clipThumb.style.display = '';
      if (clipThumb.getAttribute('aria-hidden') !== 'false') clipThumb.setAttribute('aria-hidden', 'false');
    }
    syncStyleChoices(scope);
    var variant = selectedVariant(scope);
    var entry = entryById(variant && variant.mediaId);
    var main = scope.querySelector('[data-auto-main-image]');
    if (main && entry) {
      var expected = sized(entry.src, 1200);
      if (main.src !== expected) setMain(scope, entry);
    }
  }
  function installExactGuards(scope) {
    var clipId = config.styleMedia[config.targetStyle];
    var clipThumb = scope.querySelector('[data-auto-thumb][data-media-id="' + clipId + '"]');
    if (clipThumb && clipThumb.dataset.hrigClipGuardBound !== 'true') {
      clipThumb.dataset.hrigClipGuardBound = 'true';
      new MutationObserver(function () { if (!applying) enforceExactState(scope); }).observe(clipThumb, {
        attributes: true,
        attributeFilter: ['hidden', 'style', 'aria-hidden']
      });
    }
    var main = scope.querySelector('[data-auto-main-image]');
    if (main && main.dataset.hrigClipGuardBound !== 'true') {
      main.dataset.hrigClipGuardBound = 'true';
      new MutationObserver(function () { if (!applying) enforceExactState(scope); }).observe(main, {
        attributes: true,
        attributeFilter: ['src', 'srcset']
      });
    }
    scope.querySelectorAll('.auto-product__choice--visual img').forEach(function (image) {
      if (image.dataset.hrigClipStyleGuardBound === 'true') return;
      image.dataset.hrigClipStyleGuardBound = 'true';
      new MutationObserver(function () { if (!applying) enforceExactState(scope); }).observe(image, {
        attributes: true,
        attributeFilter: ['src', 'srcset', 'alt']
      });
    });
  }
  function hydrate() {
    if (applying) return;
    var scope = root();
    if (!scope) return;
    var wrap = scope.querySelector('.auto-product__thumbs');
    if (!wrap) return;
    applying = true;
    var allowed = config.entries.map(function (entry) { return String(entry.id); });
    scope.querySelectorAll('[data-auto-thumb]').forEach(function (thumb) {
      var keep = allowed.indexOf(String(thumb.getAttribute('data-media-id') || '')) !== -1;
      thumb.hidden = !keep;
      thumb.style.display = keep ? '' : 'none';
      thumb.setAttribute('aria-hidden', keep ? 'false' : 'true');
    });
    config.entries.forEach(function (entry, index) { ensureThumb(scope, wrap, entry, index); });
    syncStyleChoices(scope);
    var variant = selectedVariant(scope);
    setMain(scope, entryById(variant && variant.mediaId));
    syncPurchase(scope, variant);
    installExactGuards(scope);
    applying = false;
    enforceExactState(scope);
  }
  function run() {
    var scope = root();
    if (!scope) return;
    hydrate();
    if (scope.dataset.hrigClipThumbnailBound === 'true') return;
    scope.dataset.hrigClipThumbnailBound = 'true';
    scope.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches('input[name^="options["]')) return;
      [0, 80, 250, 700, 1400].forEach(function (delay) { window.setTimeout(hydrate, delay); });
    });
    var observer = new MutationObserver(function () { if (!applying) window.setTimeout(hydrate, 20); });
    observer.observe(scope, { childList: true, subtree: true });
  }
  run();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  [150, 500, 1300, 3000, 6000, 10000].forEach(function (delay) { window.setTimeout(hydrate, delay); });
})();
// END hrigPlusOneGloveClipThumbnail20260716
